import formatDistanceToNow from 'date-fns/distance_in_words_to_now';
import { logError } from '@zg-rentals/log-error';

const THUMBNAIL_HEIGHT_PIXELS = '420';
const THUMBNAIL_WIDTH_PIXELS = '468';

export const getPreviewUrl = (
  previewUrlBase,
  { width = THUMBNAIL_WIDTH_PIXELS, height = THUMBNAIL_HEIGHT_PIXELS, resizeType = 'fill' } = {},
) => {
  try {
    let previewUrl = new URL(previewUrlBase);
    previewUrl.searchParams.append('width', width);
    previewUrl.searchParams.append('height', height);
    previewUrl.searchParams.append('resizeType', resizeType);
    return previewUrl.toString();
  } catch (e) {
    logError({ error: 'income verification document URL was invalid', context: previewUrlBase });
    return previewUrlBase;
  }
};

export const getExpirationStatus = (expirationDateUtc) =>
  expirationDateUtc ? `Expires in ${formatDistanceToNow(expirationDateUtc)}` : null;

export const getFileNameWithoutExtension = (name) => name.substr(0, name.lastIndexOf('.')) || name;
